import { ExternalLink } from 'lucide-react';

export function CreatorLinks({ variant = 'footer' }: { variant?: 'footer' | 'compact' | 'hero' | 'settings' }) {
  const linkedin = 'https://www.linkedin.com/in/mindful-abhay/';
  const bmc = 'https://buymeacoffee.com/abhaypratapsingh';

  if (variant === 'hero') {
    return (
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-[var(--text-muted)]">
        <span className="font-medium text-[var(--text)]">A private instrument by Abhay Pratap Singh</span>
        <a
          href={linkedin}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 hover:text-[var(--accent)] transition-colors"
        >
          LinkedIn <ExternalLink size={14} />
        </a>
        <a
          href={bmc}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 hover:text-[var(--accent)] transition-colors"
        >
          Buy me a coffee <ExternalLink size={14} />
        </a>
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <div className="flex items-center gap-4 text-xs text-[var(--text-subtle)]">
        <a href={linkedin} target="_blank" rel="noopener noreferrer" className="hover:text-[var(--text-muted)] transition-colors">
          LinkedIn
        </a>
        <span className="opacity-30">•</span>
        <a href={bmc} target="_blank" rel="noopener noreferrer" className="hover:text-[var(--text-muted)] transition-colors">
          Support the work
        </a>
      </div>
    );
  }

  if (variant === 'settings') {
    return (
      <div className="pt-6 border-t border-[var(--border)] text-sm">
        <div className="text-[var(--text-muted)] mb-2">Courage Rehearsal was made by Abhay Pratap Singh</div>
        <div className="flex flex-wrap gap-x-5 gap-y-1 text-[var(--text)]">
          <a href={linkedin} target="_blank" rel="noopener noreferrer" className="hover:underline inline-flex items-center gap-1">
            LinkedIn <ExternalLink size={13} />
          </a>
          <a href={bmc} target="_blank" rel="noopener noreferrer" className="hover:underline inline-flex items-center gap-1">
            Buy me a coffee <ExternalLink size={13} />
          </a>
        </div>
        <p className="mt-3 text-xs text-[var(--text-subtle)] max-w-prose">
          If this tool helps you carry less dread into your work, consider supporting it. No paywall, ever.
        </p>
      </div>
    );
  }

  // default footer
  return (
    <div className="pt-10 border-t border-[var(--border)] mt-10 text-sm">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 text-[var(--text-muted)]">
        <div>Courage Rehearsal is crafted by Abhay Pratap Singh</div>
        <div className="flex items-center gap-5">
          <a href={linkedin} target="_blank" rel="noopener noreferrer" className="hover:text-[var(--text)] inline-flex items-center gap-1.5 transition-colors">
            LinkedIn <ExternalLink size={15} />
          </a>
          <a href={bmc} target="_blank" rel="noopener noreferrer" className="hover:text-[var(--text)] inline-flex items-center gap-1.5 transition-colors">
            Buy me a coffee <ExternalLink size={15} />
          </a>
        </div>
      </div>
      <p className="mt-3 text-xs text-[var(--text-subtle)] max-w-prose">
        Built for people whose work matters to them and who are tired of the dread that comes with caring.
        Nothing here is designed to capture your attention or manufacture motivation.
      </p>
    </div>
  );
}
